RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';


    const POST_TAG_ALL = '__ALL__';
    const POST_TAG_UNTAGGED = '__UNTAGGED__';
    views.PostTagsFilter = RivalIQ.apps.Dashboard.views.MultiSelectDropdown.mixin({

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            postTagManagerEventing: RivalIQ.postTags.mixins.PostTagsEventingMixin
        },

        className: 'multi-select-dropdown post-tags-dropdown',

        postTagManagerEvents: {
            'postTag:changed': 'onPostTagChanged',
            'postTag:deleted': 'onPostTagDeleted',
            'postTag:applied': 'onPostTagApplied',
            'postTag:unapplied': 'onPostTagUnapplied',
            'postTag:created': 'onPostTagCreated'
        },

        ui: _.defaults({
            advancedToggle: '.post-tags-advanced-settings-toggle',
            advancedSection: '.post-tags-advanced-settings',
            conjunctionRadio: 'input[type="radio"], label',
            invalidQueryWarning: '.post-tags-invalid-query'
        }, RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.ui),

        events: _.defaults({
            'click @ui.advancedToggle': 'onAdvancedToggleClicked',
            'change @ui.conjunctionRadio': 'onConjunctionChanged'
        }, RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.events),

        template: '#postTagsDropdownTemplate',

        initialize: function () {
            const me = this;

            RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.initialize.apply(me, arguments);

            me.postTagsById = me.getOption('postTagsById');
            me.postTagIds = me.getOption('postTagIds');
        },

        onCheckboxChange: function (e) {
            const me = this;

            const $target = $(e.target);
            const changedId = $target.data('post-tag-id');
            const checked = Boolean($target.prop('checked'));

            let newSelectableItems;
            if (changedId === POST_TAG_ALL) {
                if (checked) {
                    newSelectableItems = _.map(me.selectableItems, function (item, idx) {
                        return _.defaults({
                            selected: (idx === 0)
                        }, item);
                    });
                } else {
                    // unclicking ALL means unselect all.
                    newSelectableItems = _.map(me.selectableItems, function (item) {
                        return _.defaults({
                            selected: false
                        }, item);
                    });
                }
            } else {
                // The user just changed a normal checkbox; Make sure ALL is no longer selected
                // if they unchecked something.
                const currentlySelectedPostTagIds = _.keyBy(me.getCheckboxesState());
                if (!checked) {
                    delete currentlySelectedPostTagIds[POST_TAG_ALL];
                }

                newSelectableItems = _.map(me.selectableItems, function (item) {
                    return _.defaults({
                        selected: Boolean(currentlySelectedPostTagIds[item.id])
                    }, item);
                });
            }

            // if all is selected, light up all the checkboxes
            if (newSelectableItems[0].selected) {
                _.each(newSelectableItems, function (item) {
                    item.selected = true;
                });
            }
            me.updateDropdownCheckboxes(newSelectableItems);

            const isAnySelected = _.some(newSelectableItems, 'selected');
            me.ui.controlButtons.toggleClass('hidden', !isAnySelected || !me._isCheckboxStateChanged());
            me.updateWarningMessageVisibility();
        },

        isHighlighted: function () {
            const me = this;

            const currentPostTagIdsProp = App.utils.getSelectedPostTagIdsArray(me.dashboardModel.getProp('postTagIds'));
            return !_.isEmpty(currentPostTagIdsProp);
        },

        _getItemStr: function (postTagHtml, count) {
            let html = $.tagHtml('span', {
                class: ['tag-name'],
                html: postTagHtml
            });

            if (!_.isUndefined(count)) {
                html += $.tagHtml('span', {
                    class: ['text-muted'],
                    html: `(${count})`
                });
            }

            return html;
        },

        onPostTagChanged: function (postTag) {
            const me = this;

            const postTagId = postTag.get('id');
            const item = _.find(me.selectableItems, {
                id: postTagId
            });
            if (!item) {
                return;
            }

            _.extend(item, {
                postTagHtml: RivalIQ.postTags.utils.postTagHtml(postTag.get('tag_name'))
            }, postTag.attributes);
            item.labelName = me._getItemStr(item.postTagHtml, item.count || 0);

            me.$el.find(`#select-container-${postTagId} .tag-name`).html(item.postTagHtml);
        },

        onPostTagDeleted: function (postTag) {
            const me = this;

            me.$el.find(`#select-container-${postTag.get('id')}`).hide();
        },

        onPostTagCreated: function (postTag) {
            const me = this;
            me.postTagsById[postTag.id] = postTag.attributes;
            me.render();
        },

        onPostTagApplied: function (postTag) {
            const me = this;
            me._updatePostTagCount(postTag, +1);
        },

        onPostTagUnapplied: function (postTag) {
            const me = this;
            me._updatePostTagCount(postTag, -1);
        },

        _updatePostTagCount: function (postTag, delta) {
            const me = this;

            if (postTag && postTag.id) {

                const item = _.find(me.selectableItems, {
                    id: postTag.id
                });

                if (item) {
                    item.count = (Number(item.count)) + delta;
                    item.labelName = me._getItemStr(item.postTagHtml, item.count || 0);
                    me.$el.find(`#select-container-${postTag.id} span.text-muted`).html(`(${item.count})`);
                }
            }
        },

        updateProp: function (newProps) {
            const me = this;

            me.setProps(newProps);

            const postSource = RivalIQ.data.channels.get(me.getProp('source'));

            const trackingProps = _.defaults({
                feature: (postSource && postSource.get('privateData') ? 'private data' : 'social posts')
            }, newProps);
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsSetPostTagIdsFilter, trackingProps);

            me.render();
        },

        applyDropdownState: function () {
            const me = this;

            let selectedPostTagIds = me.getCheckboxesState().sort();
            const isAllSelected = _.includes(selectedPostTagIds, POST_TAG_ALL);
            if (isAllSelected) {
                selectedPostTagIds = [];
            }

            selectedPostTagIds = _.without(selectedPostTagIds, POST_TAG_ALL);

            const newProps = {};
            const currentPostTagIdsProp = App.utils.getSelectedPostTagIdsArray(me.dashboardModel.getProp('postTagIds'));
            if (!_.isEqual(selectedPostTagIds, currentPostTagIdsProp)) {
                newProps.postTagIds = selectedPostTagIds.join(',');
            }

            const advancedFilterPropsState = me.getAdvancedFilterPropsState();
            _.each(me.getAdvancedFilterFormState(), function (value, key) {
                if (advancedFilterPropsState[key] !== value) {
                    newProps[key] = value;
                }
            });

            me.updateProp(newProps);
        },

        getLabelName: _.constant('Post Tags'),

        // NOTE: this needs to be overriding render as opposed to being in an onRender method like we'd normally do because
        // custom dashboards does some terrible things and does not call onRender.
        render: function () {
            const me = this;

            RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.render.apply(me, arguments);

            me.requestRenderedFrame(() => me.onFilterKeyup());
        },

        onFilterKeyup: function () {
            const me = this;

            const filter = me.ui.filterInput.val();

            const visibleItemIds = _.keyBy(me.getVisibleItemIds(filter));

            let updatedFirstVisible = false;
            _.each(me.selectableItems, function (selectableItem) {
                const $item = me.$el.find(`#select-container-${selectableItem.id}`);
                if (visibleItemIds[selectableItem.id]) {
                    $item.show();

                    if (!updatedFirstVisible && !_.includes([POST_TAG_ALL, POST_TAG_UNTAGGED], selectableItem.id)) {
                        $item.addClass('first-visible');
                        updatedFirstVisible = true;
                    } else {
                        $item.removeClass('first-visible');
                    }
                } else {
                    $item.hide();
                    $item.removeClass('first-visible');
                }
            });

            me.ui.searchClear.toggleClass('display-none', _.isEmpty(filter));
        },

        getVisibleItemIds: function (filter) {
            const me = this;

            const lcFilter = filter.toLocaleLowerCase();
            return _(me.selectableItems)
                .filter(function (item) {
                    return _.includes([POST_TAG_ALL, POST_TAG_UNTAGGED], item.id) ||
                        !lcFilter ||
                        _.includes(item.tag_name.toLocaleLowerCase(), lcFilter);
                })
                .map('id')
                .value();
        },

        getSelectionSummary: function (selectableItems) {
            const me = this;

            const MAX_SUMMARY_LENGTH_CHARS = 25;

            if (selectableItems[0].selected) {
                return 'All Tags';
            }

            const untaggedSelected = selectableItems[1].selected;
            const selectedTags = _.filter(selectableItems, function (postTag) {
                if (_.includes([POST_TAG_ALL, POST_TAG_UNTAGGED], postTag.id)) {
                    return 0;
                }
                return (postTag.selected ? 1 : 0);
            });

            if (!untaggedSelected && _.isEmpty(selectedTags)) {
                return 'All Tags';
            }

            if (untaggedSelected) {
                selectedTags.splice(0, 0, 'Untagged');
            }
            let summaryParts = [selectedTags[0]];

            function makeSummaryString(tags) {

                const parts = _.map(tags, function (tag) {
                    return _.get(tag, ['postTagHtml'], tag);
                });

                const numOthers = selectedTags.length - tags.length;
                if (numOthers) {
                    parts.push(`${numOthers} ${RivalIQ.formatter.numericLabel('other', 'others', numOthers)}`);
                }

                const postTagConjunction = me.getAdvancedFilterPropsState().postTagConjunction;
                if (parts.length <= 2) {
                    return parts.join(` ${postTagConjunction} `);
                } else {
                    return `${_.take(parts, parts.length - 1).join(', ')}, ${postTagConjunction} ${_.last(parts)}`;
                }
            }

            const remainingSelectedTags = _.tail(selectedTags);
            while (remainingSelectedTags.length > 0) {
                const tag = remainingSelectedTags.shift();

                const tags = summaryParts.concat([tag]);
                const currentString = makeSummaryString(tags);
                if (currentString.length > MAX_SUMMARY_LENGTH_CHARS) {
                    // adding tag to the summary makes it too long, bail without adding it in.
                    break;
                } else {
                    summaryParts = tags;
                }
            }

            return makeSummaryString(summaryParts);
        },

        getSelectableItems: function () {
            const me = this;

            const postTags = RivalIQ.postTags.utils.getPostTags(_.keys(me.postTagsById), me.postTagsById);

            const selectedPostTagIds = _.keyBy(App.utils.getSelectedPostTagIdsArray(me.dashboardModel.getProp('postTagIds')));

            const postTagIdCounts = _.keyBy(me.postTagIds, _.head);

            const postTagSelectableItems = _.map(postTags, function (postTag) {
                const count = _.get(postTagIdCounts, [postTag.id, 1], 0);
                return _.extend({
                    id: postTag.id,
                    count: count,
                    labelName: me._getItemStr(postTag.postTagHtml, count || 0),
                    selected: Boolean(selectedPostTagIds[postTag.id])
                }, postTag);
            });

            const isAllSelected = _.isEmpty(selectedPostTagIds);
            const isUntaggedSelected = isAllSelected || selectedPostTagIds[POST_TAG_UNTAGGED];

            if (isAllSelected) {
                _.each(postTagSelectableItems, function (postTag) {
                    postTag.selected = true;
                });
            }

            return [{
                id: POST_TAG_ALL,
                labelName: me._getItemStr('All'),
                tag_name: 'All',
                selected: isAllSelected
            }, {
                id: POST_TAG_UNTAGGED,
                labelName: me._getItemStr('Untagged', _.get(postTagIdCounts, [POST_TAG_UNTAGGED, 1])),
                tag_name: 'Untagged',
                selected: isUntaggedSelected
            }].concat(postTagSelectableItems);
        },

        getAdvancedFilterPropsState: function () {
            const me = this;

            let postTagExclude = me.getProp('postTagExclude') || false;
            if (_.isString(postTagExclude)) {
                postTagExclude = (postTagExclude === 'true');
            }

            return {
                postTagConjunction: me.getProp('postTagConjunction') || 'OR',
                postTagExclude: postTagExclude
            };
        },

        getAdvancedFilterFormState: function () {
            return {
                postTagConjunction: $('input[name="postTagConjunction"]:checked').val(),
                postTagExclude: $('input[name="postTagExclude"]:checked').val() === 'true'
            };
        },

        onConjunctionChanged: function () {
            const me = this;

            if (!_.isEqual(me.getAdvancedFilterFormState(), me.getAdvancedFilterPropsState())) {
                me.ui.controlButtons.toggleClass('hidden', false);
            }

            me.updateWarningMessageVisibility();
        },

        _isCheckboxStateChanged: function () {
            const me = this;

            return (!_.isEqual(me.getAdvancedFilterFormState(), me.getAdvancedFilterPropsState()) ||
                RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype._isCheckboxStateChanged.apply(me, arguments));
        },

        serializeData: function () {
            const me = this;

            const advancedSettings = me.getAdvancedFilterPropsState();
            const showAdvancedSettings = (advancedSettings.postTagConjunction !== 'OR' || advancedSettings.postTagExclude);

            return _.defaults({
                showAdvancedSettings: showAdvancedSettings
            }, me.getAdvancedFilterPropsState(), RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.serializeData.apply(me, arguments));
        },

        onShow: function () {
            const me = this;

            me.updateWarningMessageVisibility();
        },

        onAdvancedToggleClicked: function () {
            const me = this;

            me.ui.advancedSection.toggleClass('hidden');
            if (me.ui.advancedSection.hasClass('hidden')) {
                me.$el.find('.post-tags-advanced-settings-toggle i').removeClass('fa-chevron-down').addClass('fa-chevron-right');
            } else {
                me.$el.find('.post-tags-advanced-settings-toggle i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
            }
        },

        updateWarningMessageVisibility: function () {
            const me = this;

            const isQueryValid = me.isQueryValid();

            me.ui.invalidQueryWarning.toggleClass('hidden', isQueryValid);
            me.ui.applyBtn.toggleClass('disabled', !isQueryValid);

            // NOTE: we want the value of the dropdown summary to be based on the current props, but the value of the checkboxes should update immediately on radio button change.
            me.ui.dropdown.toggleClass('post-tag-exclude-applied', me.getAdvancedFilterPropsState().postTagExclude);
            me.ui.dropdownMenu.toggleClass('post-tag-exclude', me.getAdvancedFilterFormState().postTagExclude);
        },

        isQueryValid: function () {
            const me = this;

            const advancedState = me.getAdvancedFilterFormState();
            const selectedPostTagIds = me.getCheckboxesState();

            let isAllSelected = _.includes(selectedPostTagIds, POST_TAG_ALL);
            if (!isAllSelected) {
                // It's possible they don't have ALL selected but have every other checkbox selected.
                isAllSelected = _.every(me.selectableItems, function (selectableItem) {
                    return selectableItem.id === POST_TAG_ALL ||
                       _.includes(selectedPostTagIds, selectableItem.id);
                });
            }

            const isUntaggedSelected = isAllSelected || _.includes(selectedPostTagIds, POST_TAG_UNTAGGED);
            const isAnotherTagSelected = _.some(selectedPostTagIds, function (postTagId) {
                return !_.includes([POST_TAG_ALL, POST_TAG_UNTAGGED], postTagId);
            });

            if (advancedState.postTagExclude && isAllSelected) {
                // Excluding ALL won't get any results.
                return false;
            }

            if (!advancedState.postTagExclude && advancedState.postTagConjunction === 'AND' && isUntaggedSelected && isAnotherTagSelected) {
                // Selecting Untagged AND anotherTag will never match any posts.
                return false;
            }

            return true;
        },

        onApplyClicked: function () {
            const me = this;

            if (!me.isQueryValid()) {
                return false;
            }

            return RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.onApplyClicked.apply(me, arguments);
        },

        resetState: function () {
            const me = this;

            RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.resetState.apply(me, arguments);

            const advancedState = me.getAdvancedFilterPropsState();
            me.$el.find(`#postTagConjunction-${advancedState.postTagConjunction}`).prop('checked', true);
            me.$el.find(`#postTagExclude-${advancedState.postTagExclude}`).prop('checked', true);

            me.ui.invalidQueryWarning.addClass('hidden');

            me.ui.dropdown.toggleClass('post-tag-exclude-applied', advancedState.postTagExclude);
            me.ui.dropdownMenu.toggleClass('post-tag-exclude', advancedState.postTagExclude);
        },

        showFilter: _.constant(true)
    });

});
